import { useState, useEffect } from "react";

export function useResendTimer(cooldownSeconds = 60) {
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    if (secondsLeft <= 0) return;
    const timer = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [secondsLeft]);

  const startTimer = () => setSecondsLeft(cooldownSeconds);

  return { secondsLeft, startTimer, isActive: secondsLeft > 0 };
}
